import React from 'react';
import { TextInput, DropdownSelector } from 'hyperdb-utils';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const labelPassword = !this.props.objectData.id
      ? 'Password *'
      : 'Password (leave blank if unchanged)';
    return (
      <fieldset>
        {
          !this.props.noGroup
            ? <DropdownSelector
                label="Group *"
                name="group"
                value={ this.props.objectData.group }
                options={ this.groupsOptions() }
                onChange={ this.handleChange.bind(this, 'group') }
              />
            : null
        }
        <TextInput
          label="Name *"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
        />
        <TextInput
          label="Email *"
          name="email"
          value={ this.props.objectData.email }
          onChange={ this.handleChange.bind(this, 'email') }
        />
        <TextInput
          label="Login *"
          name="login"
          value={ this.props.objectData.login }
          onChange={ this.handleChange.bind(this, 'login') }
        />
        <TextInput
          label={ labelPassword }
          name="password"
          inputType="password"
          value={ this.props.objectData.password }
          onChange={ this.handleChange.bind(this, 'password') }
        />
        <TextInput
          label= { `Confirm password ${ !this.props.objectData.id ? ' *' : '' }` }
          name="confirm_password"
          inputType="password"
          value={ this.props.objectData.confirm_password }
          onChange={ this.handleChange.bind(this, 'confirm_password') }
        />
      </fieldset>
    );
  }

  groupsOptions(groups) {
    return ['admin', 'manager', 'owner', 'cleaning_staff'].map(group => {
      return { name: group, value: group };
    });
  }
  handleChange(attributeName, field) {
    if (this.props.onChange) {
      this.props.onChange(attributeName, field);
    } else {
      const { name, value } = field;
      this.props.api.user.updateEditedObject({ attributeName, value });
    }
  }
  handleChangeRelation(attributeName, field) {
    const reference = { ...this.props.objectData[attributeName] };
    reference.value[1] = field.value;
    this.handleChange(attributeName, { value: reference });
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/users/components/Form.jsx